<div class="page">
  <section class="main">
    <img class="mover" [src]="'/assets/img/logo-mover.svg' | formatAbsolute" alt="Lekkerland Mover">
    <div class="text">
      @if (variant() === 'cms') {
        <h1>Wir sind bald zurück.</h1>
        <p>Wir aktualisieren gerade den Lekkerland Shop für Sie.</p>
        <p><strong>Schauen Sie in Kürze wieder vorbei!</strong></p>
      } @else if (maintenanceOverlayData; as data) {
        <h1>{{ data.headline }}</h1>
        <p class="lead">{{ data.description }}</p>
        <p class="lead"><strong>{{ data.actionText }}</strong></p>
      } @else {
        <h1>Es ist ein Fehler aufgetreten.</h1>
        <p class="lead">Bitte kontaktieren Sie unseren Kundendienst.</p>
        <p class="lead"><strong>Telefonisch unter <span class="contact">02234/ 9314-444</span> oder per E-Mail an <span class="contact">digitalsupport&#64;lekkerland.de</span></strong></p>
      }
    </div>
  </section>

    <footer>
      <ul class="legal-menu">
        <li><a href="https://www.lekkerland.de/impressum/" target="_blank">Impressum</a></li>
        <li><a href="https://www.lekkerland.de/datenschutz/" target="_blank">Datenschutz</a></li>
      </ul>
      @if (variant() !== 'cms') {
        <div class="copyright">&copy; Lekkerland SE</div>
      }
    </footer>
</div>
